import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from '@angular/material/core';
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as moment from 'moment';
import { FuseSharedModule } from 'src/@fuse/shared.module';
import { CUSTOM_DATE_FORMATS } from 'src/app/shared';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatTooltipModule,
    NgClass,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule,
    MatTableModule,
    MatTooltipModule,
    FuseSharedModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
})
export class DatePickerComponent implements OnInit {
  @Input() label = 'Fecha';
  @Input() minDate?: Date;
  @Input() val: any;
  @Input() required!: boolean;
  @Input() disabled = false;
  @Output() dateChange = new EventEmitter<any>();
  @ViewChild('valueModel') valueInput!: ElementRef;
  @ViewChild('picker') picker!: MatDatepicker<any>;
  control: FormControl = new FormControl();
  minDateShow: any;
  fechaInvalida = false;

  ngOnInit() {
    if (this.minDate) {
      this.minDate = new Date(
        this.minDate.getFullYear(),
        this.minDate.getMonth(),
        this.minDate.getDate(),
      );
    }
    this.configControl();
  }

  configControl() {
    const fecha = moment(this.val, 'DD/MM/YYYY');
    if (fecha.isValid()) {
      this.control.setValue(fecha.format('DD/MM/YYYY'));
    }
  }

  onInputBlur(): void {
    this.resetValidators();
    const inputValue = this.valueInput.nativeElement.value;
    const parts = inputValue.split('/');
    const dateInputFormat = `${parts[1]}/${parts[0]}/${parts[2]}`;
    const dateInput = new Date(dateInputFormat);
    this.control.setValue(dateInput);
    if (inputValue.trim() === '') {
      this.control.setValidators([Validators.required]);
      this.control.setErrors({ required: true });
    }
    if (isNaN(dateInput.getTime())) {
      this.dateChange.emit('');
      this.control.setErrors({ fechaInvalida: true });
    } else if (dateInput.getTime() < this.minDate!.getTime()) {
      this.dateChange.emit('');
      this.control.setErrors({ fechaMinInvalida: true });
    } else {
      this.valueInput.nativeElement.value = moment(
        dateInput,
        'DD/MM/YYYY',
      ).format('DD/MM/YYYY');
      this.dateChange.emit(this.valueInput.nativeElement.value.toString());
    }
  }

  autoDateFormat(event: KeyboardEvent): void {
    const inputValue = this.valueInput.nativeElement.value as string;
    if (inputValue.match('//')) {
      if (inputValue.slice(0, -1).endsWith('/')) {
        this.valueInput.nativeElement.value = inputValue.slice(0, -1);
      }
    } else if (
      inputValue &&
      (inputValue.length === 2 || inputValue.length === 5) &&
      event.key !== 'Backspace'
    ) {
      this.valueInput.nativeElement.value = inputValue + '/';
    }
  }

  private resetValidators() {
    if (this.control.hasError('fechaInvalida')) {
      delete this.control.errors!['fechaInvalida'];
    }
    if (this.control.hasError('fechaMinInvalida')) {
      delete this.control.errors!['fechaMinInvalida'];
    }
    if (this.control.hasError('required')) {
      delete this.control.errors!['required'];
    }
    this.control.updateValueAndValidity({ onlySelf: true });
  }

  resetComponent() {
    this.control.reset();
  }

  hasDateError(): boolean {
    return this.control?.invalid;
  }

  getDateErrorTooltip(): string {
    if (this.control.hasError('required')) {
      return 'Fecha es requerido';
    } else if (this.control.hasError('fechaInvalida')) {
      return 'Fecha invalida';
    } else if (this.control.hasError('fechaMinInvalida')) {
      return `La fecha debe ser mayor a ${moment(this.minDate, 'DD/MM/YYYY').format('DD/MM/YYYY')}`;
    } else if (this.control.value) {
      return '';
    }
    return 'Fecha es requerido';
  }
}
